export const fixTextAlignmentForApple = () => {
  if (/Mac|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    document.body.classList.add('sk-apple-device');
  }
}
